import React, { FC, useCallback, useMemo, useState } from 'react';
import toast from 'react-hot-toast';

import { getPollVoters } from '@utils/Poll';
import useSwr from 'swr';

export interface PollVoterListProps {
  pollId: string;
  onAction?: (userId: string, option: string) => any;
}

const PollVoterList: FC<PollVoterListProps> = ({ pollId, onAction }) => {
  const [modal, setModal] = useState<boolean>(false);
  const hideModal = useCallback(() => setModal(false), [setModal]);
  const showModal = useCallback(() => setModal(true), [setModal]);

  const { data } = useSwr(['/poll/voters', pollId], getPollVoters, {
    revalidateOnFocus: false,
    onError: (err, key) => {
      console.log('Failed to fetch representatives', { key }, err);
      toast.error(err?.message || err?.errors?.[0]?.message);
    },
  });

  const voterData = useMemo(() => {
    if (!data?.data?.result?.items) return undefined;
    const voters = {};
    const filtered = data.data.result.items.filter((voter) => {
      if (voters[voter.userID] !== undefined) {
        voters[voter.userID] = voters[voter.userID] + 1;
        return false;
      }

      voters[voter.userID] = 1;
      return true;
    });
    return filtered;
  }, [data]);

  console.log(voterData);

  return (
    <>
      <div className="flex flex-col divide-opacity-30 divide-y-1 divide-solid ">
        {voterData?.map((rep) => {
          let text = rep.user?.email || rep.id;
          if (rep.user.firstName && rep.user.lastName) {
            text = `${rep.user.firstName} ${rep.user.lastName}`;
          } else if (rep.user.firstName) {
            text = rep.user.firstName;
          }
          if (rep.user.username !== text) {
            text += ` (${rep.user.username})`;
          }
          return (
            <div
              key={`rep-${rep.id}`}
              className="flex items-center justify-between py-2"
            >
              <div>{text}</div>
              <button
                className="px-2"
                onClick={
                  onAction
                    ? () => onAction(rep.userID, rep.option.id)
                    : undefined
                }
              >
                Remove
              </button>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PollVoterList;
